module.exports = __webpack_public_path__ + "img/97.4b6d4102.jpg";